import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AddOnCreationDTO, AddOnDTO, AddOnUpdateDTO, findAllAddOnsFiltersDTO, findAllAddOnsResponseDTO } from "./dto";
import { NewAddOnService } from "./service";
import { PromiseStatuses } from "../../../../utils";

interface AddOnState {
    addOnCreateRequest: AddOnCreationDTO;
    addOnUpdateRequest: AddOnUpdateDTO;
    findAllAddOnsResponse?: findAllAddOnsResponseDTO
    findAllAddOnsStatus: PromiseStatuses;
    addOnCreateStatus: PromiseStatuses
    addOnUpdateStatus: PromiseStatuses
    getAddOnByIdStatus: PromiseStatuses
    getAddOnByIdResponse?: AddOnDTO
    deleteAddOnStatus: PromiseStatuses
}

const initialState: AddOnState = {
    addOnCreateRequest: {
        starting: null,
        ending: null,
        addOn: "",
        addModule: null,
        customerDataId: "",
        active: false
    },
    addOnUpdateRequest: {
        starting: null,
        ending: null,
        addOn: "",
        addModule: null,
        active: false
    },
    findAllAddOnsStatus: "idle",
    addOnCreateStatus: "idle",
    addOnUpdateStatus: "idle",
    getAddOnByIdStatus: "idle",
    deleteAddOnStatus: "idle"
}

export const createAddOn = createAsyncThunk(
    'addOn/createAddOn',
    async (request: AddOnCreationDTO, thunkApi): Promise<number> => {
        const addOnService = NewAddOnService()

        return addOnService.createAddOn(request).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })

    },
)

export const updateAddOn = createAsyncThunk(
    'addOn/updateAddOn',
    async (request: { id: string, data: AddOnUpdateDTO }, thunkApi): Promise<void> => {
        const addOnService = NewAddOnService()

        return addOnService.updateAddOn(request.id, request.data).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })

    },
)

export const getAddOns = createAsyncThunk(
    'addOn/getAddOns',
    async (filters: findAllAddOnsFiltersDTO, thunkApi): Promise<findAllAddOnsResponseDTO> => {
        const addOnService = NewAddOnService()

        return addOnService.getAddOns(filters)
    },
)

export const getAddOnById = createAsyncThunk(
    'addOn/getAddOnById',
    async (id: string, thunkApi): Promise<AddOnDTO> => {
        const addOnService = NewAddOnService()

        return addOnService.getAddOnById(id)
    },
)

export const deleteAddOn = createAsyncThunk(
    'addOn/deleteAddOn',
    async (id: string, thunkApi): Promise<void> => {
        const addOnService = NewAddOnService()

        return addOnService.deleteAddOn(id)
    },
)

const addOnSlice = createSlice({
    name: 'addOn/slice',
    initialState,
    reducers: {

    },
    extraReducers(builder) {
        builder
            .addCase(getAddOns.pending, (state) => {
                state.findAllAddOnsStatus = 'loading'
            })
            .addCase(getAddOns.fulfilled, (state, action) => {
                state.findAllAddOnsStatus = 'successfully'
                state.findAllAddOnsResponse = action.payload
            })
            .addCase(getAddOns.rejected, (state) => {
                state.findAllAddOnsStatus = 'failed'
            })
            .addCase(getAddOnById.pending, (state) => {
                state.getAddOnByIdStatus = 'loading'
            })
            .addCase(getAddOnById.fulfilled, (state, action) => {
                state.getAddOnByIdStatus = 'successfully'
                state.getAddOnByIdResponse = action.payload
            })
            .addCase(getAddOnById.rejected, (state) => {
                state.getAddOnByIdStatus = 'failed'
            })
            .addCase(createAddOn.pending, (state) => {
                state.addOnCreateStatus = 'loading'
            })
            .addCase(createAddOn.fulfilled, (state, action) => {
                state.addOnCreateStatus = 'successfully'
            })
            .addCase(createAddOn.rejected, (state) => {
                state.addOnCreateStatus = 'failed'
            })
            .addCase(updateAddOn.pending, (state) => {
                state.addOnUpdateStatus = 'loading'
            })
            .addCase(updateAddOn.fulfilled, (state, action) => {
                state.addOnUpdateStatus = 'successfully'
            })
            .addCase(updateAddOn.rejected, (state) => {
                state.addOnUpdateStatus = 'failed'
            })
            .addCase(deleteAddOn.pending, (state) => {
                state.deleteAddOnStatus = 'loading'
            })
            .addCase(deleteAddOn.fulfilled, (state) => {
                state.deleteAddOnStatus = 'successfully'
            })
            .addCase(deleteAddOn.rejected, (state) => {
                state.deleteAddOnStatus = 'failed'
            })
    },
})

export const {

} = addOnSlice.actions

export default addOnSlice.reducer